import { render } from "./add-roles.vue?vue&type=template&id=6e688814"
import script from "./add-roles.vue?vue&type=script&lang=js"
export * from "./add-roles.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__